<template>
  <el-dialog
    title="修改商会简介"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >
    <div class="product-add pb50">
      <el-form
        size="small"
        :model="form"
        ref="form"
        :rules="rules"
        label-width="100px"
      >
        <div class="common-form">修改商会简介</div>
        
        <el-form-item label="商会简介名称" prop="name">
          <el-input
            v-model="form.name"
            placeholder="请输入商会简介名称"
            class="max-w460"
          ></el-input>
        </el-form-item>

        <el-tabs v-model="selectMap" @tab-click="handleClick">
          <div>
            <el-form-item label="地址" prop="address">
              <el-input
                v-model="form.address"
                placeholder="请输入地址"
                class="max-w460"
              ></el-input>
            </el-form-item>
            <el-form-item label="坐标" prop="coordinate">
              <el-row class="mb16">
                <el-col :span="24">
                  <el-input
                    v-model="form.coordinate"
                    class="max-w460"
                  ></el-input>
                </el-col>
              </el-row>
              <el-row class="mb16">
                <el-col :span="24">
                  <Getpoint
                    v-if="selectMap == 1"
                    :form="form"
                    @getMapdata="getMapdataFunc"
                    @chose="choseFunc"
                  ></Getpoint>
                </el-col>
              </el-row>
            </el-form-item>
          </div>
        </el-tabs>

        <el-form-item label="电话" prop="phone">
          <el-input
            v-model="form.phone"
            placeholder="请输入电话"
            class="max-w460"
          ></el-input>
        </el-form-item>

        <el-form-item label="邮箱" prop="email">
          <el-input
            v-model="form.email"
            placeholder="请输入邮箱"
            class="max-w460"
          ></el-input>
        </el-form-item>

<el-form-item label="商会资质" prop="aptitudes">
  <div v-for="(item, index) in form.aptitudes" :key="index" class="aptitude-item">
    <el-input
      v-model="form.aptitudes[index]"
      placeholder="请输入商会资质"
      class="max-w460"
    ></el-input>
    <el-button
      v-if="index > 0"
      @click.prevent="removeAptitude(index)"
      type="danger"
      icon="el-icon-minus"
      circle
      class="ml-10"
    ></el-button>
    <el-button
      @click.prevent="addAptitude"
      v-if="index === form.aptitudes.length - 1"
      type="primary"
      icon="el-icon-plus"
      circle
      class="ml-10"
      :disabled="form.aptitudes.length >= 10 || !form.aptitudes[index]"
    ></el-button>
  </div>
</el-form-item>
        <!-- <el-form-item label="商会资质" prop="aptitude">
          <div v-for="(item, index) in form.aptitudes" :key="index" class="aptitude-item">
            <el-input
              v-model="form.aptitudes[index]"
              placeholder="请输入商会资质"
              class="max-w460"
              maxlength="100"
              show-word-limit
            ></el-input>
            <el-button
              v-if="index > 0"
              @click="removeAptitude(index)"
              type="danger"
              icon="el-icon-minus"
              circle
              class="ml-10"
            ></el-button>
            <el-button
              @click="addAptitude"
              v-if="index === form.aptitudes.length - 1 && form.aptitudes.length < 10"
              type="primary"
              icon="el-icon-plus"
              circle
              class="ml-10"
            ></el-button>
          </div>
        </el-form-item> -->

        <el-form-item label="选择商会核心成员" prop="shop_core_member_id">
          <el-select
            v-model="form.shop_core_member_id"
            multiple
            filterable
            placeholder="请选择商会核心成员"
            style="width: 100%"
            :loading="loadingShopCoreMembers"
          >
            <el-option
              v-for="shopCoreMember in shopCoreMemberList"
              :key="shopCoreMember.shop_core_member_id"
              :label="shopCoreMember.name"
              :value="shopCoreMember.shop_core_member_id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="商会图片" prop="bannar">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.bannar">
              <transition-group>
                <div v-for="(item, index) in form.bannar" :key="item.file_path">
                  <div class="item">
                    <img v-img-url="item.file_path" alt="file_path" />
                    <a
                      href="javascript:void(0);"
                      class="delete-btn"
                      @click.stop="deleteImg(index, 'bannar')"
                      ><i class="el-icon-close"></i
                    ></a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('bannar')">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="商会简介介绍">
          <div class="edit_container">
            <Uediter
              v-model="form.intro"
              :text="ueditor.text"
              :config="ueditor.config"
              ref="ue"
            ></Uediter>
          </div>
        </el-form-item>

        <el-form-item label="排序" prop="sort">
          <el-input
            v-model="form.sort"
            placeholder="请输入排序"
            class="max-w460"
          ></el-input>
        </el-form-item>

        <div class="common-button-wrapper">
          <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
          <el-button
            size="small"
            type="primary"
            @click="onSubmit"
            :loading="loading"
            >提交</el-button
          >
        </div>
      </el-form>
      
      <Upload
        v-if="isProductUpload"
        :config="{ total: 9 }"
        :isupload="isProductUpload"
        @returnImgs="returnProductImgsFunc"
        >上传图片
      </Upload>
    </div>
  </el-dialog>
</template>

<script>
import Shop_introApi from "@/api/shop_intro.js";
import CommerceApi from "@/api/commerce.js";
import Getpoint from "@/components/map/Getpoint.vue";
import Upload from "@/components/file/Upload";
import draggable from "vuedraggable";
import Uediter from "@/components/UE.vue";

export default {
  components: {
    Upload,
    draggable,
    Uediter,
    Getpoint
  },
  data() {
    return {
      loadingShopCoreMembers: false,
      shopCoreMemberList: [],
      loadingShopIntros: false,
      shopIntroList: [],
      selectMap: "1",
      isupload: false,
      isImg: false,
      ueditor: {
        text: "",
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      form: {
        shop_core_member_id: [],
        address: "",
        coordinate: "",
        aptitudes: [''], // 初始化为包含一个空字符串的数组
        name: "",
        code: "custom",
        image: [],
        sort: 50,
        intro: "",
        bannar: []
      },
      loading: false,
      rules: {
        name: [
          { required: true, message: "请输入商会简介名称", trigger: "blur" }
        ],
        aptitudes: {
    validator: (rule, value, callback) => {
      // 过滤掉最后一个空值后再验证
      const valuesToValidate = value.slice(0, -1);
      
      if (valuesToValidate.some(item => item && item.length > 100)) {
        callback(new Error('每个资质内容不能超过100字符'));
      } else if (valuesToValidate.length > 10) {
        callback(new Error('最多只能添加10个资质'));
      } else {
        callback();
      }
    },
    trigger: 'blur'
  },

      },
      dialogVisible: false,
      isProductUpload: false,
      code: "album"
    };
  },
  created() {
    this.dialogVisible = this.open_add;
    this.getDetail();
    
    this.addShopIntroList();
    this.addShopCoreMemberList();
  },
  props: ["open_add", "shop_intro_id"],
  methods: {
    handleFocus(index) {
    this.$nextTick(() => {
      const inputs = this.$el.querySelectorAll('.aptitude-item .el-input__inner');
      if (inputs[index]) {
        inputs[index].focus();
      }
    });
  },
  
  addAptitude() {
  if (this.form.aptitudes.length >= 10) return;
  this.form.aptitudes.push('');
},

removeAptitude(index) {
  if (this.form.aptitudes.length <= 1) return;
  this.form.aptitudes.splice(index, 1);
},
    
    addShopIntroList() {
      CommerceApi.listx({}, true)
        .then(data => {
          this.shopIntroList = data.data;
        })
        .catch(error => {
          console.error('获取商会列表失败:', error);
        });
    },
    
    addShopCoreMemberList() {
      this.loadingShopCoreMembers = true;
      Shop_introApi.shopCoreMemberListx({}, true)
        .then(data => {
          this.shopCoreMemberList = data.data;
          this.loadingShopCoreMembers = false;
        })
        .catch(error => {
          console.error('获取核心成员列表失败:', error);
          this.loadingShopCoreMembers = false;
        });
    },
    
    handleClick(tab, event) {
      console.log(tab, event);
    },
    
    getMapdataFunc(e) {
      this.form.coordinate = e.data[0].toFixed(6) + "," + e.data[1].toFixed(6);
    },
    
    choseFunc(e) {
      this.form.coordinate = e.location.lat + "," + e.location.lng;
      this.form.address = e.address;
    },
    
    dialogFormVisible(result) {
      this.$emit("close", {});
    },
    
    cancelFunc() {
      this.dialogFormVisible("error");
    },
    
    getDetail() {
  let self = this;
  self.loading = true;
  Shop_introApi.detail({ shop_intro_id: self.shop_intro_id }, true)
    .then(res => {
      self.form = {
        ...res.data,
        aptitudes: Array.isArray(res.data.aptitude) 
          ? [...res.data.aptitude, ''] 
          : (typeof res.data.aptitude === 'string' 
              ? [...JSON.parse(res.data.aptitude || '[]'), '']
              : [''])
      };
          // 处理shop_core_member_id
          if (self.form.shop_core_member_id && typeof self.form.shop_core_member_id === 'string') {
            try {
              self.form.shop_core_member_id = JSON.parse(self.form.shop_core_member_id);
            } catch (e) {
              console.error('解析shop_core_member_id失败:', e);
              self.form.shop_core_member_id = [];
            }
          } else if (!self.form.shop_core_member_id) {
            self.form.shop_core_member_id = [];
          }
          
          // 处理bannar
          if (self.form.bannar && typeof self.form.bannar === 'string') {
            try {
              self.form.bannar = JSON.parse(self.form.bannar);
            } catch (e) {
              console.error('解析bannar失败:', e);
              self.form.bannar = [];
            }
          } else if (!self.form.bannar) {
            self.form.bannar = [];
          }
      self.loading = false;
    });
},
  
    
    onSubmit() {
      let self = this;
      let form = JSON.parse(JSON.stringify(this.form));
      
      // 转换aptitudes为aptitude并过滤空值
      form.aptitude = form.aptitudes.filter(item => item && item.trim() !== '');
      delete form.aptitudes;
      
      form.shop_intro_id = self.shop_intro_id;
      form.intro = this.$refs.ue.getUEContent();
      
      // 确保shop_core_member_id是数组
      if (!Array.isArray(form.shop_core_member_id)) {
        form.shop_core_member_id = form.shop_core_member_id ? [form.shop_core_member_id] : [];
      }
      
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Shop_introApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: "success"
              });
              self.dialogFormVisible("error");
            })
            .catch(error => {
              self.loading = false;
              self.$message.error('提交失败，请稍后重试');
            });
        }
      });
    },
    
    openProductUpload(code) {
      this.isProductUpload = true;
      this.code = code;
    },
    
    returnProductImgsFunc(e) {
      if (this.code == "album") {
        if (e != null) {
          let imgs = this.form.image.concat(e);
          this.$set(this.form, "image", imgs);
        }
      } else {
        if (e != null) {
          let imgs = this.form.bannar.concat(e);
          this.$set(this.form, "bannar", imgs);
        }
      }
      this.isProductUpload = false;
    },
    
    deleteImg(index, code) {
      if (code == "album") {
        this.form.image.splice(index, 1);
      } else if (code == "bannar") {
        this.form.bannar.splice(index, 1);
      }
    }
  }
};
</script>

<style scoped>
/* 保持原有样式不变 */
.product-add {
  position: relative;
}
.edit_container {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

.aptitude-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.aptitude-item:last-child {
  margin-bottom: 0;
}
.ml-10 {
  margin-left: 10px;
}
.max-w460 {
  max-width: 460px;
}
.pb50 {
  padding-bottom: 50px;
}
.common-button-wrapper {
  margin-top: 20px;
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/shop_intro/index/part/edit.vue